import { GetIdeaResponse, PostIdeaType } from '@orbit/api-types'
import api from '@lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useCreateIdea = () => {
	const queryClient = useQueryClient()

	return useMutation<GetIdeaResponse, Error, { tripId: string; ideaData: PostIdeaType }>({
		mutationFn: async ({ ideaData }) => {
			const response = await api.post<GetIdeaResponse>(`/ideas`, ideaData)
			return response.data
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['ideas', variables.tripId] })
		},
	})
}
